export const EVENT_DATA_TYPE = 'event'
export const EVENT_DATA_ID = 'data-event-id'
